export default "__VITE_ASSET__sGsEsU_3__"